import React from "react";

export function SectionLabel({ children, color = "#3F4CE0" }) {
  return (
    <p className="font-mono-label text-[11px] font-medium mb-4" style={{ color }}>{children}</p>
  );
}

export function RiskBadge({ level }) {
  const map = {
    Low: "bg-[#12B76A]/10 text-[#0E9355] border-[#12B76A]/25",
    Moderate: "bg-[#F59E0B]/10 text-[#B45309] border-[#F59E0B]/25",
    Elevated: "bg-[#E8590C]/10 text-[#C2410C] border-[#E8590C]/25",
    High: "bg-[#E5484D]/10 text-[#DC2626] border-[#E5484D]/30"
  };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full border font-mono-label text-[10px] ${map[level] || map.Moderate}`}>{level}</span>;
}

export function Chip({ children, className = "" }) {
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full border border-[#E7E0D2] bg-white font-mono-label text-[10px] text-[#1A1914]/60 ${className}`}>{children}</span>;
}

export const riskColors = { Low: "#12B76A", Moderate: "#F59E0B", Elevated: "#E8590C", High: "#E5484D" };

export function fmtB(v) {
  if (v == null) return "—";
  return v >= 1000 ? `$${(v / 1000).toFixed(1)}T` : `$${v.toFixed(1)}B`;
}
